export const IS_ALREADY_APPLY_TRANSFER_AGENCY_SERVICE = 'isAlreadyApplyTransferAgencyService';
export const IS_ALREADY_APPLY_PURCHASE_ACCOMPANYING_SERVICE = 'isAlreadyApplyPurchaseAccompanyingService';
export const IS_ALREADY_APPLY_ONE_STOP_SERVICE = 'isAlreadyApplyOneStopService';
export const IS_ALREADY_APPLY_CAPITAL_COUNSEL_SERVICE = 'isAlreadyApplyCapitalCounselService';
export const IS_ALREADY_APPLY_LEASE_SERVICE = 'isAlreadyApplyLeaseService';
export const IS_RESERVE_LEASE_TRUCK_NOTIFICATION = 'isReserveLeaseTruckNotification';
